import {ResponsiveLayout} from '@frontend/components/ResponsiveLayout'
import {useFooterStore} from '@frontend/stores'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {FooterDesktop} from './FooterDesktop'
import {FooterMobile} from './FooterMobile'

// Нижняя часть страницы со ссылками и копирайтом.
// Макет: десктоп 577:9013, мобильный 577:9343.
export function Footer() {

    const show = useFooterStore(
        state => state.visible
    )

    return (
        <Collapse
            tag="footer"
            show={show}
            showImmediately
        >
            <div className="container-fluid container-xl pb-5">
                <ResponsiveLayout
                    desktop={<FooterDesktop />}
                    wideTablet={<FooterDesktop />}
                    tablet={<FooterMobile />}
                    mobile={<FooterMobile />}
                />
            </div>
        </Collapse>
    )
}
